function Home() {
  return (
    <section className='home'>
      <section className='hero is-fullheight-with-navbar'>
        <div className='hero-body'>
          <div className='container'>
            <h1 className='title is-1 has-text-centered'>
            Superduper Heros
            </h1>
          </div>
        </div>
      </section>
    </section>
  )
}

export default Home